import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute} from '@angular/router';


@Component({
    //templateUrl: 'app/authentication/reset-password-success.component.html'
    template: require('./reset-password-success.component.html'),
})
 
export class ResetPasswordSuccessComponent {
    //doesn't do anything'
}
 


/** WEBPACK FOOTER **
 ** ./app/authentication/reset-password-success.component.ts
 **/